// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AccountPickerController from "./admin/account_picker_controller";
import AddSubquestionController from "./admin/add_subquestion_controller";
import AttendeeTypeSelectorController from "./admin/attendee_type_selector_controller";
import ChartController from "./admin/chart_controller";
import CrossEventReportsController from "./admin/cross_event_reports_controller";
import CrossEventReportsModalController from "./admin/cross_event_reports_modal_controller";
import CrossEventReportsTurboFrameController from "./admin/cross_event_reports_turbo_frame_controller";
import EventBookingPagesSearchDatesController from "./admin/event_booking_pages_search_dates_controller";
import ExpenseController from "./admin/expense_controller";
import ExpenseReportController from "./admin/expense_report_controller";
import FieldMappingController from "./admin/field_mapping_controller";
import InternalMessagesController from "./admin/internal_messages_controller";
import InvitePreviewController from "./admin/invite_preview_controller";
import MultiCheckboxController from "./admin/multi_checkbox_controller";
import MultiSelectActionsController from "./admin/multi_select_actions_controller";
import MultiSelectTableController from "./admin/multi_select_table_controller";
import OrgEventTypeController from "./admin/org_event_type_controller";
import PreviewTemplateSelectionController from "./admin/preview_template_selection_controller";
import ProgressController from "./admin/progress_controller";
import PushExpenseReportController from "./admin/push_expense_report_controller";
import RegistrationFieldController from "./admin/registration_field_controller";
import RegistrationInvite from "./admin/registration_invite_controller";
import RegistrationResponsesController from "./admin/registration_responses_controller";
import SearchAndFilterController from "./admin/search_and_filter_controller";
import SortableTableController from "./admin/sortable_table_controller";
import TotalAmountController from "./admin/total_amount_controller";
import MatcherSlidersController from "./matcher_sliders_controller";
import DropzoneController from "./dropzone_controller";
import PromptSelectorController from "./prompt_selector_controller";

application.register("account-picker", AccountPickerController);
application.register("add-subquestion", AddSubquestionController);
application.register("attendee-type-selector", AttendeeTypeSelectorController);
application.register("chart", ChartController);
application.register("cross-event-reports", CrossEventReportsController);
application.register(
  "cross-event-reports-modal",
  CrossEventReportsModalController,
);
application.register(
  "cross-event-reports-turbo-frame",
  CrossEventReportsTurboFrameController,
);
application.register(
  "ebp-search-dates",
  EventBookingPagesSearchDatesController,
);
application.register("expense", ExpenseController);
application.register("expense-report", ExpenseReportController);
application.register("field-mapping", FieldMappingController);
application.register("internal-messages", InternalMessagesController);
application.register("invite-preview", InvitePreviewController);
application.register("multi-checkbox", MultiCheckboxController);
application.register("multi-select-actions", MultiSelectActionsController);
application.register("multi-select-table", MultiSelectTableController);
application.register("org-event-type", OrgEventTypeController);
application.register(
  "preview-template-selection",
  PreviewTemplateSelectionController,
);
application.register("progress", ProgressController);
application.register("push-expense-report", PushExpenseReportController);
application.register("registration-field", RegistrationFieldController);
application.register("registration-responses", RegistrationResponsesController);
application.register("registration-invite", RegistrationInvite);
application.register("search-and-filter", SearchAndFilterController);
application.register("sortable-table", SortableTableController);
application.register("total-amount", TotalAmountController);
application.register("matcher-sliders", MatcherSlidersController);
application.register("dropzone", DropzoneController);
application.register("prompt-selector", PromptSelectorController);
